import React from 'react';
import {TextInput, Edit, SimpleForm, required,ImageInput, ImageField, Toolbar, DeleteButton} from 'react-admin';
import {makeStyles, Theme} from '@material-ui/core';
import {HASHTAG_CATEGORY} from '../../consts/Names';
import BaseListActions from '../BaseListActions';
import {Validators} from '../../consts/Validators';
import {Messages} from '../../consts/Messages';
import { WithProps, SaveWithUpdateButton } from '../utils/RecordWrappers';

const useStyles = makeStyles((theme: Theme) => ({
   form: {
      display: 'flex',
      flexDirection: 'column'
   },

   textFld: {
      width: '300px',
      marginTop: '1em'
   },
   imageFld: {
      display: 'flex',
      width: '300px'
   },
   toolBar:{
      flex: 1,
      display: "flex",
      "justify-content": "space-between"
   },
}));

const reWorkingRecord = (record) => {
   let newRecord = Object.assign({}, record);
   newRecord.image = {'image':record.image}
   return newRecord;
}

const reworkedData = (props) => {
   if (props.image.rawFile === undefined)
       delete props.image;
   return Object.assign({}, props);
};
   

const EditToolbar = (props) => {
   const {className} = props;
   return(
   <Toolbar {...props} className={className}>
      <SaveWithUpdateButton replaceFunction={reworkedData} updatedSource={HASHTAG_CATEGORY.SOURCE} redirect={`/${HASHTAG_CATEGORY.SOURCE}/`} 
      submitOnEnter={false} variant="text"  undoable={false} />
      <DeleteButton  undoable={false}/>
   </Toolbar>
)}
const validateStock = [required(), Validators.minValue(3, Messages.MIN_VALUE)];

export const HashTagCategoriesEdit = (props) => {
   const {theme, basePath} = props;
   const classes = useStyles(theme);

   return (
      <Edit {...props} actions={<BaseListActions basePath={basePath} />} title="Edit category for hashtags"  undoable={false}>
         <WithProps callBackFunc={reWorkingRecord}>{({record,...props})=>
            <SimpleForm  {...props} record={record} toolbar={<EditToolbar {...props} className={classes.toolBar}/>}>
               <TextInput className={classes.textFld} label="Category Name" source={HASHTAG_CATEGORY.name} validate={validateStock} />
               <ImageInput className={classes.imageFld} source="image" label="Related picture" accept="image/*" validate={required()} placeholder={<p>Drop your image here</p>}>
                  <ImageField source={'image'} title="title" />
               </ImageInput>
            </SimpleForm>
         }
         </WithProps>
      </Edit>
   );
};
